import React from 'react';
import { PropTypes } from 'prop-types';
import { Route, Link } from 'react-router-dom';

const MenuLink = ({to, exact, children, ...props}) => {
  return (
    <Route path={to} exact={exact} children={({match}) => (
        <li className={match && "active"}>
            <Link to={to} {...props}>{children}</Link>
        </li>
    )}/>
  );
}

MenuLink.propTypes = {
  to: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export default MenuLink;



// WEBPACK FOOTER //
// ./src/components/shared/MenuLink.js